export const HexClasses = {
  HEX_ANCHOR_BUTTON: "hex-anchor-button",
  HEX_BUTTON: "hex-button",
  HEX_COLLAPSE_TOGGLE_HEADER: "hex-collapse-toggle-header",
  HEX_COLLAPSE_TOGGLE_WRAPPER: "hex-collapse-toggle-wrapper",
  HEX_COLLAPSE_HEADER: "hex-collapse-header",
};
